import "./StoreTabs.scss";

export const StoreTabs = (props) => {
  const { packageData, active, setActive } = props;

  const changeTab = (tab) => setActive(tab);

  return (
    <div className="tabs-container">
      <div className="tabs">
        <div
          className={`tab ${active === "details" ? "active" : ""}`}
          onClick={() => changeTab("details")}
        >
          Course Details
        </div>
        <div
          className={`tab ${active === "desc" ? "active" : ""}`}
          onClick={() => changeTab("desc")}
        >
          Description
        </div>
        {packageData?.subject && packageData.subject.length > 0 && (
          <div
            className={`tab ${active === "subjects" ? "active" : ""}`}
            onClick={() => changeTab("subjects")}
          >
            Subjects
          </div>
        )}
      </div>
    </div>
  );
};
